module.exports = __webpack_public_path__ + "a6b1bcee52015c536cc533830cee2184.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_70.jpg
// module id = 1720
// module chunks = 5